
import { Summary } from "../../state/models";
import { isAgent, pushEvent } from "./pushEvent";

export function pushCheckoutEvent({summary}: {summary: Summary}) {
  
  if(isAgent()) return;

  if(!summary || !Array.isArray(summary.segments) || summary.bookingTotal < 0) return;

  const items = summary.segments.map(segment => ({
    item_id: `${segment.carrierCode}${segment.flightNumber}@${segment.departureDate}`,
    item_name: `${segment.originCode}-${segment.destinationCode}@${segment.departureDate}`,
    item_category: 'flight',
    price: segment.segmentTotal,
    tax: segment.taxTotal,
    quantity: 1
  }));

  const data = {
    currency: summary.currencyCode,
    value: summary.bookingTotal,
    items
  }

  pushEvent({ event: 'begin_checkout', data})
}